import { render, staticRenderFns } from "./HtmlEditorTiptap.vue?vue&type=template&id=673d01ba&"
import script from "./HtmlEditorTiptap.vue?vue&type=script&lang=js&"
export * from "./HtmlEditorTiptap.vue?vue&type=script&lang=js&"
import style0 from "./HtmlEditorTiptap.vue?vue&type=style&index=0&id=673d01ba&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports